import Http from 'app/services/core/Http.service'
import { DATA_URL, CKLA_HUB_CAROUSEL_DATA } from 'app/constants/api.constants'

const HttpService = new Http()

export const getKnowledgeBuilders = () =>
  HttpService.getData(DATA_URL.KNOWLEDGEBUILDERS)

export const getFloridaKnowledgeBuilders = () =>
  HttpService.getData(DATA_URL.KNOWLEDGEBUILDERS_FL)

export const getKnowledgeBuilder = (id: string) =>
  HttpService.getData(DATA_URL.KNOWLEDGE(id))

export const getEbooks = (
  key: keyof Omit<typeof DATA_URL, 'KNOWLEDGE'>,
  contentToken: string
) =>
  HttpService.getData(DATA_URL[key], {
    'ckla-content-token': contentToken,
  })

export const getSounds = (
  soundCategory: keyof Omit<typeof DATA_URL, 'KNOWLEDGE'>
) => HttpService.getData(DATA_URL[soundCategory])

export const getTeacherGuideData = (page: string) =>
  HttpService.getData(`${CKLA_HUB_CAROUSEL_DATA}/${page}`)
